(() => {
  const init = (root) => {
    if (root.dataset.nnReady) return;
    root.dataset.nnReady = 'true';
    const angle = root.dataset.angle;
    const current = new URL(window.location.href);
    root.querySelectorAll('[data-nn-product]').forEach((link) => {
      const target = new URL(link.href, window.location.origin);
      current.searchParams.forEach((value, key) => {
        if (key.startsWith('utm_') || ['fbclid', 'gclid'].includes(key)) target.searchParams.set(key, value);
      });
      target.searchParams.set('steadia_angle', angle);
      target.searchParams.set('steadia_source', 'native-listicle');
      link.href = target.href;
      link.addEventListener('click', () => {
        window.Shopify?.analytics?.publish?.('steadia_native_lander_cta', {
          angle,
          placement: link.dataset.placement || 'article',
          destination: target.pathname,
        });
      });
    });
    const sticky = root.querySelector('[data-nn-sticky]');
    const hero = root.querySelector('[data-nn-hero]');
    const offer = root.querySelector('[data-nn-offer]');
    if (sticky && hero && offer && 'IntersectionObserver' in window) {
      let pastHero = false;
      let atOffer = false;
      const update = () => { sticky.hidden = !pastHero || atOffer; };
      const heroObserver = new IntersectionObserver(([entry]) => {
        pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        update();
      });
      const offerObserver = new IntersectionObserver(([entry]) => {
        atOffer = entry.isIntersecting;
        update();
      }, { rootMargin: '0px 0px 120px 0px' });
      heroObserver.observe(hero);
      offerObserver.observe(offer);
    }

  };
  const mount = () => document.querySelectorAll('[data-native-listicle]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
